<template>
  <rect x="24" width="40" height="36" rx="3" fill="#424242" />
  <path
    d="M36.5 12.266L41.495 10.5288C41.495 10.5288 42.1024 11.9454 44.005 11.9454C45.9076 11.9454 46.5083 10.5 46.5083 10.5L51.5 12.266L50.6692 16.6222H48.1642V24.5H39.825V16.6196H37.3325L36.5 12.266Z"
    fill="#F9F9F9" />
  <rect x="27" y="39" width="34" height="7" rx="3" fill="#424242" />
  <rect x="32" y="49" width="24" height="7" rx="3" fill="#424242" />
</template>
